import React, { useMemo } from 'react'
import { ReadOnlyField } from 'src/component/profile/personal-info/read-only-field'
import { useSessionContext } from 'src/context/session-context'

export const ReadProfile = (): React.ReactElement => {
  const { me } = useSessionContext()

  const isLoading = useMemo(() => !me, [me])

  return (
    <>
      <div className="flex items-center justify-between !mb-5">
        <h6 className="font-evogria text-sm md:text-base text-ivory uppercase">Profile</h6>
      </div>
      <div className="space-y-3">
        <ReadOnlyField label="Email" value={me?.email || '—'} isLoading={isLoading} />
      </div>
    </>
  )
}
